export const aboutObj = {
  id: 'about',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Liberia Motocycle & Tricycle Security Service',
  headline: 'Secure your ride on the go',
  description: 'The Liberia Motocycle & Tricycle Security Service is a Liberia cyber based security institution that was established in 2024, to provide security for motocycle and Tricycle operators and users across Liberia.',
  description1: 'We are engage in enumeration and coding of all legitimately owned motocycle or tricycle across the fifteen(15) counties and sub-regions. Due to higher theft rate, commercial and privately owned motocycle or tricycle operator and users are venrable to criminals, because of the value and ease of resale of vehicles.',
  description2: 'Ensuring security will help protect investments and livelihoods for many families who rely on these vehicless for income and transportation. We the Liberia Motocycle & Tricycle Security Service (LMTSS) look up to you for your coorporation.',
  buttonLabel: 'Get started',
  imgStart: false,
  img: require('../../images/svg-1.svg'),
  alt: 'Car',
  dark: true,
  primary: true,
  darkText: false
};

export const discoverObj = {
  id: 'discover',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Get to know us more',
  headline: 'Our Mission',
  headline1: 'Our Vission',
  headline2: 'Our Core Value',
  description: 'We provide a robust security solution to motocycle or tricycle users and operators. We aid national development by creating a safer and secure society through enhanced collaboration among all stockholders and security agencies.',
  description1: 'To be the leading provider of security services amongst institution, and seek the warfare of motocycle and tricycle operators, and the vast population.',
  description2: 'In our quest to render service to motocycle owners, operators and the general public, we have committed ourselves to the following core value.',
  buttonLabel: 'Get started Now',
  imgStart: true,
  img: require('../../images/svg-2.svg'),
  alt: 'Car',
  dark: true,
  primary: true,
  darkText: true
};

export const signupObj = {
  id: 'signup',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Create a new account',
  headline: 'Creating an account is extremely easy',
  description: 'Create a new account unless you already have one, and enjoy our offerings',
  buttonLabel: 'Get started',
  imgStart: false,
  img: require('../../images/svg-3.svg'),
  alt: 'svg3',
  dark: false,
  primary: false,
  darkText: true
};
